import type { ReactNode } from "react";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Closing";

export function LegalPage({
  eyebrow,
  title,
  subtitle,
  updated,
  children,
}: {
  eyebrow: string;
  title: string;
  subtitle?: string;
  updated?: string;
  children: ReactNode;
}) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Nav />
      <main>
        <section className="relative pt-32 pb-16 border-b border-border overflow-hidden">
          <div className="absolute inset-0 led-grid opacity-20" />
          <div className="absolute inset-0 bg-gradient-to-b from-background/0 via-background/60 to-background" />
          <div className="relative mx-auto max-w-4xl px-6">
            <p className="text-xs uppercase tracking-[0.3em] text-primary mb-4">{eyebrow}</p>
            <h1 className="font-display text-4xl sm:text-6xl leading-[1.05]">{title}</h1>
            {subtitle && (
              <p className="mt-6 text-lg text-muted-foreground max-w-2xl leading-relaxed">
                {subtitle}
              </p>
            )}
            {updated && (
              <p className="mt-6 text-[11px] uppercase tracking-[0.25em] text-muted-foreground">
                Last Updated · {updated}
              </p>
            )}
          </div>
        </section>

        <section className="py-20">
          <div className="mx-auto max-w-3xl px-6">
            <div className="legal-prose space-y-10 text-[15px] leading-[1.75] text-muted-foreground">
              {children}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export function LegalSection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="space-y-4">
      <h2 className="font-display text-2xl sm:text-3xl text-foreground tracking-tight">
        {title}
      </h2>
      <div className="space-y-4">{children}</div>
    </section>
  );
}
